"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.symbol.description.js");

var _ = require("./");

class TrainingModule {
  static thaw(trainingModuleObj) {
    if (trainingModuleObj == null) return null;
    const trainingModule = new TrainingModule();
    if (trainingModuleObj.id != null) trainingModule.setId(trainingModuleObj.id);
    if (trainingModuleObj.name != null) trainingModule.setName(trainingModuleObj.name);
    if (trainingModuleObj.isActive != null) trainingModule.setIsActive(trainingModuleObj.isActive);
    if (trainingModuleObj.segmentId != null) trainingModule.setSegmentId(trainingModuleObj.segmentId);
    if (trainingModuleObj.displayImageUrl != null) trainingModule.setDisplayImageUrl(trainingModuleObj.displayImageUrl);
    if (trainingModuleObj.segment != null) trainingModule.setSegment(_.ErgoAlgoSegment.thaw(trainingModuleObj.segment));
    if (trainingModuleObj.evaluatorTrainings != null) trainingModule.setEvaluatorTrainings(_.EvaluatorTraining.thawList(trainingModuleObj.evaluatorTrainings));
    if (trainingModuleObj.requiredForSegments != null) trainingModule.setRequiredForSegments(_.ErgoAlgoSegment.thawList(trainingModuleObj.requiredForSegments));
    if (trainingModuleObj.notes != null) trainingModule.setNotes(trainingModuleObj.notes);
    if (trainingModuleObj.description != null) trainingModule.setDescription(trainingModuleObj.description);
    if (trainingModuleObj.hasAccess != null) trainingModule.setHasAccess(trainingModuleObj.hasAccess);
    if (trainingModuleObj.isCompleted != null) trainingModule.setIsCompleted(trainingModuleObj.isCompleted);
    return trainingModule;
  }

  static thawList(trainingModuleObjList) {
    if (trainingModuleObjList == null) return [];
    var trainingModules = [];

    for (var i = 0; i < trainingModuleObjList.length; i++) {
      trainingModules.push(TrainingModule.thaw(trainingModuleObjList[i]));
    }

    return trainingModules;
  }

  static freeze(trainingModule) {
    if (trainingModule == null) return null;
    var trainingModuleObj = {};
    if (trainingModule.getId() != null) trainingModuleObj.id = trainingModule.getId();
    if (trainingModule.getName() != null) trainingModuleObj.name = trainingModule.getName();
    if (trainingModule.getIsActive() != null) trainingModuleObj.isActive = trainingModule.getIsActive();
    if (trainingModule.getSegmentId() != null) trainingModuleObj.segmentId = trainingModule.getSegmentId();
    if (trainingModule.getDisplayImageUrl() != null) trainingModuleObj.displayImageUrl = trainingModule.getDisplayImageUrl();
    if (trainingModule.getSegment() != null) trainingModuleObj.segment = _.ErgoAlgoSegment.freeze(trainingModule.getSegment());
    if (trainingModule.getEvaluatorTrainings() != null) trainingModuleObj.evaluatorTrainings = _.EvaluatorTraining.freezeList(trainingModule.getEvaluatorTrainings());
    if (trainingModule.getRequiredForSegments() != null) trainingModuleObj.requiredForSegments = _.ErgoAlgoSegment.freezeList(trainingModule.getRequiredForSegments());
    if (trainingModule.getNotes() != null) trainingModuleObj.notes = trainingModule.getNotes();
    if (trainingModule.getDescription() != null) trainingModuleObj.description = trainingModule.getDescription();
    if (trainingModule.getHasAccess() != null) trainingModuleObj.hasAccess = trainingModule.getHasAccess();
    if (trainingModule.getIsCompleted() != null) trainingModuleObj.isCompleted = trainingModule.getIsCompleted();
    return trainingModuleObj;
  }

  static freezeList(trainingModules) {
    if (trainingModules == null) return [];
    var trainingModuleObjList = [];

    for (var i = 0; i < trainingModules.length; i++) {
      trainingModuleObjList.push(TrainingModule.freeze(trainingModules[i]));
    }

    return trainingModuleObjList;
  }

  constructor() {
    this.setId(null);
    this.setName(null);
    this.setIsActive(null);
    this.setSegmentId(null);
    this.setDisplayImageUrl(null);
    this.setSegment(null);
    this.setEvaluatorTrainings(null);
    this.setRequiredForSegments(null);
    this.setNotes(null);
    this.setDescription(null);
    this.setHasAccess(null);
    this.setIsCompleted(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setName(name) {
    this.name = name;
  }

  setIsActive(isActive) {
    this.isActive = isActive;
  }

  setSegmentId(segmentId) {
    this.segmentId = segmentId;
  }

  setDisplayImageUrl(displayImageUrl) {
    this.displayImageUrl = displayImageUrl;
  }

  setSegment(segment) {
    this.segment = segment;
  }

  setEvaluatorTrainings(evaluatorTrainings) {
    this.evaluatorTrainings = evaluatorTrainings;
  }

  setRequiredForSegments(requiredForSegments) {
    this.requiredForSegments = requiredForSegments;
  }

  setNotes(notes) {
    this.notes = notes;
  }

  setDescription(description) {
    this.description = description;
  }

  setHasAccess(hasAccess) {
    this.hasAccess = hasAccess;
  }

  setIsCompleted(isCompleted) {
    this.isCompleted = isCompleted;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getIsActive() {
    return this.isActive;
  }

  getSegmentId() {
    return this.segmentId;
  }

  getDisplayImageUrl() {
    return this.displayImageUrl;
  }

  getSegment() {
    return this.segment;
  }

  getEvaluatorTrainings() {
    return this.evaluatorTrainings;
  }

  getRequiredForSegments() {
    return this.requiredForSegments;
  }

  getNotes() {
    return this.notes;
  }

  getDescription() {
    return this.description;
  }

  getHasAccess() {
    return this.hasAccess;
  }

  getIsCompleted() {
    return this.isCompleted;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  className() {
    return 'TrainingModule';
  }

}

exports.default = TrainingModule;